import { useState, useMemo } from 'react'

import {
	EuiButton,
	EuiTitle,
	EuiFieldSearch,
	EuiPanel,
	EuiFlexGroup,
	EuiFlexItem,
	EuiSpacer,
} from '@equipmentshare/ds2'

import DataGrid from 'views/components/DataGrid'

import createColumns from './columns'
import { GroupQuery } from 'graphql'

export type User = GroupQuery['group']['users'][number]

/** A user row, with the display name the table column reads. */
export type UserRow = User & { fullName: string }

type Props = {
	isLoading: boolean,
  onAddUserClick: any,
  confirmDeleteUser: any,
  users: User[],
}

export default function GroupUsersTable( { onAddUserClick, isLoading, confirmDeleteUser, users }: Props ) {
	const [ search, setSearch ] = useState( '' )
	const columns = createColumns( confirmDeleteUser )

	const onSearchChange = ( event: React.ChangeEvent<HTMLInputElement> ) => setSearch( event.currentTarget.value )

	const filteredUsers = useMemo( () => {
		const rows: UserRow[] = users.map( ( u ) => ( { ...u, fullName: `${u.firstName} ${u.lastName}` } ) )
		if ( search === '' ) {
			return rows
		}
		const lowerCaseSearch = search.toLowerCase()
		return rows.filter( ( u ) => u.fullName.toLowerCase().includes( lowerCaseSearch ) )
	}, [ users, search ] )

	return (
		<>
			<EuiFlexGroup alignItems="center" gutterSize="xl">
				<EuiFlexItem grow={false}>
					<EuiTitle size="s"><h2>Users</h2></EuiTitle>
				</EuiFlexItem>
				<EuiFlexItem grow={false}>
					<EuiButton
						onClick={onAddUserClick}
						size="s"
						iconType="plus"
						color="text"
					>
						Add user
					</EuiButton>
				</EuiFlexItem>
			</EuiFlexGroup>
			<EuiSpacer size="m" />
			<EuiFieldSearch
				value={search}
				onChange={onSearchChange}
				placeholder="Search users"
			/>
			<EuiSpacer />
			<EuiPanel paddingSize="none" className="eui-yScroll" hasShadow={false}>
				<DataGrid
					isLoading={isLoading}
					emptyStateText="No users found."
					columns={columns}
					rows={filteredUsers}
				/>
			</EuiPanel>
		</>
	)
}
